var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Idiomas","titleIcon":"fas fa-language"}},[_c('catalogo-crud',{attrs:{"tipo":"idioma","rotuloNovo":"NOVO IDIOMA","nomeSingular":"idioma","placeholderBusca":"Pesquisar por nome ou sigla","campos":_vm.campos,"colunas":_vm.colunas,"dialogLargura":"480px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }